import CancelIcon from '@mui/icons-material/HighlightOffOutlined'
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined'

const emptyRow = () => ({ fecha: '', capital: '', interes: '', otrosCargos: '', glosa: '', total: 0 })
const moneyFields = [['capital', 'Capital'], ['interes', 'Intereses'], ['otrosCargos', 'Otros cargos']]
const formatAmount = value => Number(value || 0).toLocaleString('es-CL')

const TablaPrestamoRecibido = ({ filasPrestamo, setFilasPrestamo, capitalReadOnly = false, onFirstDateChange }) => {
  const handleChange = (index, field, value) => {
    if (capitalReadOnly && field === 'capital') return
    if (index === 0 && field === 'fecha') onFirstDateChange?.(value)
    setFilasPrestamo(rows => rows.map((row, i) => {
      if (i !== index) return row
      const updated = { ...row, [field]: value }
      return { ...updated, total: Number(updated.capital || 0) + Number(updated.interes || 0) + Number(updated.otrosCargos || 0) }
    }))
  }
  const inputClass = 'w-full rounded-md border border-gray-300 bg-white px-2 py-2 text-xs text-gray-700 shadow-sm transition-colors placeholder:text-gray-400 hover:border-gray-400 focus:border-accent2 focus:outline-none focus:ring-2 focus:ring-accent2/20'
  return (
    <div className='overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
      <div className='overflow-x-auto'>
      <table className='w-full min-w-[1000px] table-fixed border-collapse text-xs font-sans'>
        <caption className='sr-only'>Cuotas del préstamo</caption>
        <thead className='bg-gray-50'>
          <tr className='text-center'>
            {['Fecha', 'Capital', 'Intereses', 'Otros cargos', 'Glosa', 'Total', 'Acciones'].map(label => <th key={label} scope='col' className={`border-b border-gray-200 px-3 py-3 font-semibold text-gray-500 ${['Capital', 'Intereses', 'Otros cargos', 'Total'].includes(label) ? 'text-right' : 'text-left'}`}>{label}</th>)}
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200'>
          {filasPrestamo.map((fila, index) => (
            <tr key={index} className='transition-colors hover:bg-gray-50 focus-within:bg-gray-50'>
              <td className='px-2 py-2 align-middle'><input aria-label={`Fecha cuota ${index + 1}`} type='date' value={fila.fecha} onChange={e => handleChange(index, 'fecha', e.target.value)} className={inputClass} /></td>
              {moneyFields.map(([field, label]) => (
                <td key={field} className='px-2 py-2 align-middle'>
                  <input aria-label={`${label} cuota ${index + 1}`} type='text' inputMode='numeric'
                    readOnly={capitalReadOnly && field === 'capital'}
                    disabled={capitalReadOnly && field === 'capital'}
                    title={capitalReadOnly && field === 'capital' ? 'El capital no se puede editar' : undefined}
                    value={fila[field] === '' ? '' : formatAmount(fila[field])}
                    onChange={e => handleChange(index, field, e.target.value.replace(/\D/g, ''))}
                    className={`${inputClass} text-right tabular-nums disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed disabled:shadow-none disabled:hover:border-gray-300`} />
                </td>
              ))}
              <td className='px-2 py-2 align-middle'><input aria-label={`Glosa cuota ${index + 1}`} type='text' value={fila.glosa || ''} onChange={e => handleChange(index, 'glosa', e.target.value)} className={inputClass} /></td>
              <td className='px-2 py-2 align-middle'><input aria-label={`Total cuota ${index + 1}`} type='text' value={formatAmount(fila.total)} readOnly className={`${inputClass} text-right tabular-nums`} /></td>
              <td className='px-2 py-2 align-middle'>
                <div className='flex items-center justify-center gap-1'>
                  <button type='button' aria-label={`Agregar cuota luego de ${index + 1}`} onClick={() => setFilasPrestamo(rows => [...rows.slice(0, index + 1), emptyRow(), ...rows.slice(index + 1)])} className='rounded-full p-1 text-accent2 transition-colors hover:bg-accent2/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent2'><AddIcon fontSize='small' /></button>
                  <button type='button' aria-label={`Eliminar cuota ${index + 1}`} disabled={filasPrestamo.length <= 1} onClick={() => setFilasPrestamo(rows => rows.length > 1 ? rows.filter((_, i) => i !== index) : rows)} className='rounded-full p-1 text-red-500 transition-colors hover:bg-red-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-500 disabled:opacity-40'><CancelIcon fontSize='small' /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  )
}

export default TablaPrestamoRecibido
